import { render } from "./StandartField.vue?vue&type=template&id=208233ab&scoped=true"
import script from "./StandartField.vue?vue&type=script&lang=js"
export * from "./StandartField.vue?vue&type=script&lang=js"

import "./StandartField.vue?vue&type=style&index=0&id=208233ab&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-208233ab"]])

export default __exports__